// 负责人电话验证
export function rainFall(str) {
  const reg = /^[0-9]*[1-9][0-9]*$/;
  return reg.test(str);
}
